import './components/ga-events';            //should be on top of each page's JS file
import './components/swipe-for-more';       // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import Tooltips from './components/tooltips';
import '../vendor/splide.min';
import './widgets/read-more';
import './components/js-links';
import './components/svg';
import './parts/about-us-nav';
import $ from 'cash-dom';
import CustomSelect from './components/custom-select';

$(function () {
  Tooltips.getInstance().initOnce();
  CustomSelect.init();
});

if ($('#posts_carousel').length) {
  new Splide('#posts_carousel').mount();
}